import React, { Fragment, ComponentType, ReactNode, useEffect, useLayoutEffect, ReactElement } from 'react'
import type { ServicesManager } from '@wix/services-manager/types'
import { ServicesManagerProvider } from '@wix/services-manager-react'

const useIsomorphicLayoutEffect = process.env.browser ? useLayoutEffect : () => {}

export type PageMountUnmountProps = {
	children: () => ReactNode
	pageDidMount: (isMounted: boolean) => void
	codeEmbedsCallback?: Function
	ComponentCss?: ReactElement
	servicesManager?: ServicesManager
	isServicesInfraOpen?: boolean
}

const PageMountUnmount: ComponentType<PageMountUnmountProps> = ({
	children,
	pageDidMount = () => {},
	codeEmbedsCallback,
	ComponentCss,
	servicesManager,
	isServicesInfraOpen,
}) => {
	useEffect(() => {
		pageDidMount(true)
		return () => pageDidMount(false)
	}, [pageDidMount])

	useIsomorphicLayoutEffect(() => {
		codeEmbedsCallback?.()
		return undefined // destroy function
	})
	const shouldWrapWithServicesContext = isServicesInfraOpen && servicesManager

	const ServiceWrapper = (shouldWrapWithServicesContext ? ServicesManagerProvider : Fragment) as (props: {
		// Export type from @wix/services-manager-react
		servicesManager: ServicesManager
		children?: React.ReactNode
	}) => React.JSX.Element
	const serviceWrapperProps = (shouldWrapWithServicesContext ? { servicesManager } : {}) as {
		servicesManager: ServicesManager
	}

	return (
		<Fragment>
			<ServiceWrapper {...serviceWrapperProps}>
				{ComponentCss}
				{children()}
			</ServiceWrapper>
		</Fragment>
	)
}

export default PageMountUnmount
